import React from "react";
import { Modal, Button } from "react-bootstrap";
import styles from "./masterData/MasterData.module.scss";

interface MasterDataConfirmationModalProps {
  show?: boolean;
  matches: Array<Record<string, any>>;
  onConfirm?: () => void;
  onClose?: () => void;
  dataKey: string;
}

const MasterDataConfirmationModal: React.FC<
  MasterDataConfirmationModalProps
> = ({ show, matches, onConfirm, onClose, dataKey }) => {
  return (
    <Modal show={show} onHide={onClose} centered className="custom-backdrop">
      <Modal.Header closeButton>
        <Modal.Title>Potential Matches Found</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Potential matches were found for the {dataKey} you&apos;re adding.
          Please review before proceeding:
        </p>
        <ul className={styles.confirmList}>
          {matches.map((match) => (
            <li key={match.id} className={styles.confirmItem}>
              <strong>{match[dataKey]}</strong> (ID: {match.id})
            </li>
          ))}
        </ul>
        <p className="mb-0 mt-3">Are you sure you want to proceed?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          Proceed
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MasterDataConfirmationModal;
